import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, Package, Search, ChevronRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export default function MobileItemsPage() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    axios.get(`${API}/items`).then(r => setItems(r.data || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const filtered = items.filter(i => !search || (i.name || '').toLowerCase().includes(search.toLowerCase()) || (i.sku || '').toLowerCase().includes(search.toLowerCase()));
  const categories = [...new Set(items.map(i => i.category).filter(Boolean))].sort();

  if (loading) return <div className="mobile-page"><div className="mobile-loading"><div className="mobile-spinner" /></div></div>;

  return (
    <div className="mobile-page">
      <button className="mobile-back-btn" onClick={() => navigate('/mobile/more')}><ArrowLeft size={18} /> More</button>
      <div className="mobile-page-title" style={{ marginBottom: 12 }}>Items</div>
      <div style={{ position: 'relative', marginBottom: 14 }}>
        <Search size={16} style={{ position: 'absolute', left: 12, top: 13, color: '#8e8e93' }} />
        <input className="mobile-input" placeholder="Search items..." value={search} onChange={e => setSearch(e.target.value)} style={{ paddingLeft: 36 }} />
      </div>
      <div className="mobile-kpi-row" style={{ marginBottom: 14 }}>
        <div className="mobile-kpi-card blue"><div className="mobile-kpi-label">Total</div><div className="mobile-kpi-value">{items.length}</div></div>
        <div className="mobile-kpi-card green"><div className="mobile-kpi-label">Categories</div><div className="mobile-kpi-value">{categories.length}</div></div>
      </div>
      {filtered.length === 0 ? <div className="mobile-empty-state"><Package /><p>No items found</p></div> : (
        <div className="mobile-menu-list">
          {filtered.map(item => (
            <button key={item.item_id} className="mobile-menu-item" onClick={() => navigate(`/mobile/items/${item.item_id}`)}>
              <div className="mobile-menu-item-icon" style={{ background: '#ff9500' }}><Package size={16} /></div>
              <div className="mobile-menu-item-content">
                <div className="mobile-menu-item-title">{item.name}</div>
                <div className="mobile-menu-item-subtitle">{item.sku || 'N/A'} · {item.category || 'N/A'} · {item.on_hand || 0} on hand</div>
              </div>
              <ChevronRight size={16} className="mobile-menu-item-chevron" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
